import {gql, TypedDocumentNode} from '@apollo/client'
import {
  JobRequestFilterInput, JobRequestSortInput,
  Query
} from 'graphql-api'
import {
  GraphQLPaginationType,
  JobRequestOrderType
} from 'commonTypes'
import client from 'api/graphQL/config'

export const GET_JOB_REQUEST_OPTIONS: TypedDocumentNode<Query> = gql`
  query GetJobRequestOptionsAsync {
    jobRequestOptions {
      category
      categoryName
      enableStudy
      isStudyRequired
      enableChangesAfterDate
      enableObjectId
      enableStudyEnvironment
      enableKafkaTopic
      enableMultipleUrlSelection
      enableDataVerificationHashObject
      kafkaTopics {
        allowChangeData
        kafkaConfigurationUuid
        kafkaTopicName
        messageType
        name
        numberOfPartitions
        replicationFactor
        topicUuid
      }
      hidden
    }
    dataVerificationHashObjectOptions
  }
  `

export const GET_JOB_STATUS_REQUEST_DETAILS = gql`
  query GetJobRequestDetails($requestId: UUID!) {
    jobRequests(where: { requestId: { eq: $requestId } }) {
      nodes {
        requestId
        created
        category
        status {
          notStarted
          inProgress
          total
          completed
          failed
          finalError
          jobCompletedTime
          enqueued
        }
        databaseId
        studyUuid
        objectId
        changesAfterDate
        categoryName
        jobCount
        completedJobCount,
        sentMessageCount,
        username
        url
        studyName
      }
    }
  }
`

export const GET_STUDIES = gql`
  query studies ($databaseId: UUID!) {
    studies(databaseId: $databaseId){
      studyUuid
      studyName
    }
  }
`

export const GET_STUDY_ENVIRONMENTS = gql`
  query studyEnvironments ($databaseId: UUID!, $studyUuid: UUID!) {
    studyEnvironments(databaseId: $databaseId, studyUuid: $studyUuid){
      studyId
      studyEnvironmentUuid
      studyEnvironmentName
    }
  }
`

export const GET_JOB_REQUESTS: TypedDocumentNode<Query> = gql`
  query GetJobRequests(
    $first: Int,
    $after: String,
    $last: Int,
    $before: String,
    $order: [JobRequestSortInput!],
    $where: JobRequestFilterInput,
  ) {
    jobRequests(
      first: $first,
      after: $after,
      last: $last,
      before: $before,
      order: $order,
      where: $where,

    ) {
     totalCount
     pageInfo {
       hasNextPage
       hasPreviousPage
       startCursor
       endCursor
     }
     nodes {
       requestId
       category
       categoryName
       objectId
       created
       jobCount
       changesAfterDate
       databaseId
       studyUuid
       studyName
       username
     }
    }
  }
  `


export const getJobRequests = (
  pagination: GraphQLPaginationType,
  order: JobRequestOrderType,
  where: JobRequestFilterInput
) => {
  const {first, after, last, before} = pagination

  return client.query({
    query: GET_JOB_REQUESTS,
    variables: {
      first,
      after,
      last,
      before,
      order,
      where,
    },
  })
}

export const getJobRequestOptions = () => {
  return client.query({
    query: GET_JOB_REQUEST_OPTIONS,
  })
}


export const jobStatusRequestDetails = (requestId: string) =>
  client.query({
    query: GET_JOB_STATUS_REQUEST_DETAILS,
    variables: {
      requestId,
    },
  })


export const getStudies = (databaseId: string) =>
  client.query({
    query: GET_STUDIES,
    variables: {
      databaseId,
    },
  })

export const getStudyEnvironments = (databaseId: string, studyUuid: string) =>
  client.query({
    query: GET_STUDY_ENVIRONMENTS,
    variables: {
      databaseId,
      studyUuid,
    },
  })
